<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			:defaultOrderByAscending="false"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("Requests"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "company_name",
					name: this.__("Company"),
				},
				{
					id: "url",
					name: this.__("Url"),
					render: (url) => url.substr(0, 100),
				},
				{
					id: "duration",
					name: this.__("Duration"),
					render: (f) => f.toFixed(2),
				},
				{
					id: "status_code",
					name: this.__("Result"),
				},
				{
					id: "created_at",
					name: this.__("Time"),
					render: options.formatIsoStamp,
				},
			],
		};
	},
};
</script>
